import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "frontend-sdks"
    }}>{`Frontend SDKs`}</h4>
    <p>{`We make a request to fetch feature flags (using the `}<a parentName="p" {...{
        "href": "/docs/api/flags"
      }}><inlineCode parentName="a">{`/flags`}</inlineCode>{` endpoint`}</a>{`) when one of the below occurs:`}</p>
    <ul>
      <li parentName="ul">{`The PostHog SDK is initialized`}</li>
      <li parentName="ul">{`A user is `}<a parentName="li" {...{
          "href": "/docs/data/identify"
        }}>{`identified`}</a>{` `}</li>
      <li parentName="ul">{`A user's `}<a parentName="li" {...{
          "href": "/docs/product-analytics/person-properties"
        }}>{`properties`}</a>{` are updated`}</li>
      <li parentName="ul">{`You call `}<inlineCode parentName="li">{`posthog.reloadFeatureFlags()`}</inlineCode>{` in your code`}</li>
      <li parentName="ul">{`You create a `}<a parentName="li" {...{
          "href": "/docs/product-analytics/group-analytics"
        }}>{`group`}</a></li>
    </ul>
    <p>{`For the `}<a parentName="p" {...{
        "href": "/docs/libraries/js"
      }}>{`JavaScript web SDK`}</a>{`, you can estimate how many feature flag requests you will make by doing the following:`}</p>
    <ol>
      <li parentName="ol">{`Check the networks tab in Chrome inspector tools for the number of `}<inlineCode parentName="li">{`/flags`}</inlineCode>{` requests`}</li>
      <li parentName="ol">{`Find out your number of monthly page views`}</li>
      <li parentName="ol">{`Multiply your number of `}<inlineCode parentName="li">{`/flags`}</inlineCode>{` requests by your monthly page views`}</li>
    </ol>
    <p>{`For example, if on refresh, you see 2 `}<inlineCode parentName="p">{`/flags`}</inlineCode>{` requests per pageview and you have ~150,000 pageviews, your monthly feature flag requests should be around ~300,000.`}</p>
    <h4 {...{
      "id": "backend-sdks"
    }}>{`Backend SDKs`}</h4>
    <h5 {...{
      "id": "without-local-evaluation"
    }}>{`Without local evaluation`}</h5>
    <p>{`If you're not using `}<a parentName="p" {...{
        "href": "/docs/feature-flags/local-evaluation"
      }}>{`local evaluation`}</a>{`, a request to get feature flags is made every time you call `}<inlineCode parentName="p">{`posthog.get_feature_flag()`}</inlineCode>{` on your backend. Your estimated usage will be however many times you are calling this code.`}</p>
    <h5 {...{
      "id": "with-local-evaluation"
    }}>{`With local evaluation`}</h5>
    <p>{`If you're using `}<a parentName="p" {...{
        "href": "/docs/feature-flags/local-evaluation"
      }}>{`local evaluation`}</a>{`, each local evaluation request is equivalent to, and charged as, 10 feature flag requests. Local evaluation calls, by default, are made every 30 seconds. Assuming your server is constantly running and making 2 requests per minute, you will be charged `}<inlineCode parentName="p">{`10 * 2 * 60 * 24 * 30 = 864,000 feature flag requests`}</inlineCode>{` each month.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` This figure is for a single server and a single instance of PostHog. If you have multiple servers, PostHog instances, or a different poll duration, you need to multiply your estimates too.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      